import React from 'react'

const data = [

    {
        id: 1,
        name: 'High Street',
        img: 'http://dev.imbibe.info/images/HighStreet/highstreet.jpeg',
        url: '/brand-design/high-street',
        slideshow: [
            'http://dev.imbibe.info/images/HighStreet/01.jpg',
            'http://dev.imbibe.info/images/HighStreet/02.jpg',
            'http://dev.imbibe.info/images/HighStreet/03.jpg',
            'http://dev.imbibe.info/images/HighStreet/04.jpg',
            'http://dev.imbibe.info/images/HighStreet/05.jpg',
        ]
    },

    {
        id: 2,
        name: 'Oak',
        img: 'http://dev.imbibe.info/images/Oak/oak.jpg',
        url: '/brand-design/oak',
        slideshow: [
            'http://dev.imbibe.info/images/Oak/01.jpg',
            'http://dev.imbibe.info/images/Oak/02.jpg',
            'http://dev.imbibe.info/images/Oak/03.jpg',
            'http://dev.imbibe.info/images/Oak/04.jpg',
            'http://dev.imbibe.info/images/Oak/05.jpg',
            'http://dev.imbibe.info/images/Oak/06.jpg',
            'http://dev.imbibe.info/images/Oak/07.jpg',
        ]
    },
    {
        id: 3,
        name: 'A&B',
        img: 'http://dev.imbibe.info/images/A&B/a&b.jpg',
        url: '/brand-design/a-b',
        slideshow: [
            'http://dev.imbibe.info/images/A&B/01.jpg',
            'http://dev.imbibe.info/images/A&B/02.jpg',
            'http://dev.imbibe.info/images/A&B/03.jpg',
            'http://dev.imbibe.info/images/A&B/04.jpg',
            'http://dev.imbibe.info/images/A&B/05.jpg',
            
        ]
    },

    {
        id: 4,
        name: 'East Works District',
        img: 'http://dev.imbibe.info/images/eastWorks/eastWorks.jpg',
        url: '/brand-design/east-works',
        slideshow: [
            'http://dev.imbibe.info/images/eastWorks/01.jpg',
            'http://dev.imbibe.info/images/eastWorks/02.jpg',
            'http://dev.imbibe.info/images/eastWorks/03.jpg',
            'http://dev.imbibe.info/images/eastWorks/04.jpg',
        ]
    },
    {
        id: 5,
        name: 'Riverton',
        img: 'http://dev.imbibe.info/images/riverton/grid.jpg',
        url: '/brand-design/riverton',
        slideshow: [
            'http://dev.imbibe.info/images/riverton/01.jpg',
            'http://dev.imbibe.info/images/riverton/02.jpg',
            'http://dev.imbibe.info/images/riverton/04.jpg',
            'http://dev.imbibe.info/images/riverton/05.jpg',
            'http://dev.imbibe.info/images/riverton/07.jpg',
        ]
    },
    {
        id: 6,
        name: 'Lorelei',
        img: 'http://dev.imbibe.info/images/lorelei/grid.jpg',
        url: '/brand-design/lorelei',
        slideshow: [
            'http://dev.imbibe.info/images/lorelei/01.jpg',
            'http://dev.imbibe.info/images/lorelei/02.jpg',
            'http://dev.imbibe.info/images/lorelei/03.jpg',
            'http://dev.imbibe.info/images/lorelei/04.jpg',
            'http://dev.imbibe.info/images/lorelei/05.jpg',
            'http://dev.imbibe.info/images/lorelei/06.jpg',
            'http://dev.imbibe.info/images/lorelei/07.jpg',
        ]
    },
    {
        id: 7,
        name: 'Colony Square',
        img: 'http://dev.imbibe.info/images/colony-square/grid.jpg',
        url: '/brand-design/colony-square',
        slideshow: [
            'http://dev.imbibe.info/images/colony-square/01.jpg',
            'http://dev.imbibe.info/images/colony-square/02.jpg',
            'http://dev.imbibe.info/images/colony-square/03.jpg',
            'http://dev.imbibe.info/images/colony-square/04.jpg',
            'http://dev.imbibe.info/images/colony-square/05.jpg',
            'http://dev.imbibe.info/images/colony-square/06.jpg',
            'http://dev.imbibe.info/images/colony-square/07.jpg',
            'http://dev.imbibe.info/images/colony-square/08.jpg',
        ]
    },
    {
        id: 8,
        name: 'The Wilbert Group',
        img: 'http://dev.imbibe.info/images/wilbert/grid.jpg',
        url: '/brand-design/wilbert',
        slideshow: [
            'http://dev.imbibe.info/images/wilbert/01.jpg',
            'http://dev.imbibe.info/images/wilbert/02.jpg',
            'http://dev.imbibe.info/images/wilbert/03.jpg',
        ]
    },
    {
        id: 9,
        name: 'North American Properties',
        img: 'http://dev.imbibe.info/images/north-american-properties/grid.jpg',
        url: '/brand-design/north-american-properties',
        slideshow: [
            'http://dev.imbibe.info/images/north-american-properties/01.jpg',
            'http://dev.imbibe.info/images/north-american-properties/02.jpg',
            'http://dev.imbibe.info/images/north-american-properties/03.jpg',
            'http://dev.imbibe.info/images/north-american-properties/04.jpg',
            'http://dev.imbibe.info/images/north-american-properties/05.jpg',
        ]
    },
    
    {
        id: 10,
        name: 'Literacy For All',
        img: 'http://dev.imbibe.info/images/literacy-for-all/grid.jpg',
        url: '/brand-design/literacy-for-all',
        slideshow: [
            'http://dev.imbibe.info/images/literacy-for-all/01.jpg',
            'http://dev.imbibe.info/images/literacy-for-all/02.jpg',
            'http://dev.imbibe.info/images/literacy-for-all/03.jpg',
            'http://dev.imbibe.info/images/literacy-for-all/04.jpg',
        ]
    },
    {
        id: 11,
        name: 'Fenton',
        img: 'http://dev.imbibe.info/images/fenton/grid.jpg',
        url: '/brand-design/fenton',
        slideshow: [
            'http://dev.imbibe.info/images/fenton/01.jpg',
            'http://dev.imbibe.info/images/fenton/02.jpg',
            'http://dev.imbibe.info/images/fenton/03.jpg',
            'http://dev.imbibe.info/images/fenton/04.jpg',
        ]
    },
    {
        id: 12,
        name: 'The Belly Art Project',
        img: 'http://dev.imbibe.info/images/belly-art/grid.jpg',
        url: '/brand-design/belly-art',
        slideshow: [
            'http://dev.imbibe.info/images/belly-art/01.jpg',
            'http://dev.imbibe.info/images/belly-art/02.jpg',
            'http://dev.imbibe.info/images/belly-art/03.jpg',
            'http://dev.imbibe.info/images/belly-art/04.jpg',
            'http://dev.imbibe.info/images/belly-art/05.jpg',
            'http://dev.imbibe.info/images/belly-art/06.jpg',
            'http://dev.imbibe.info/images/belly-art/07.jpg',
            'http://dev.imbibe.info/images/belly-art/08.jpg',
            'http://dev.imbibe.info/images/belly-art/09.jpg',
            'http://dev.imbibe.info/images/belly-art/10.jpg',
        ]
    },
    {
        id: 13,
        name: 'Behavioral Science Technologies',
        img: 'http://dev.imbibe.info/images/behavioral-science-technologies/grid.jpg',
        url: '/brand-design/behavioral-science-technologies',
        slideshow: [
            'http://dev.imbibe.info/images/behavioral-science-technologies/01.jpg',
            'http://dev.imbibe.info/images/behavioral-science-technologies/02.jpg',
            'http://dev.imbibe.info/images/behavioral-science-technologies/03.jpg',
            'http://dev.imbibe.info/images/behavioral-science-technologies/04.jpg',
        ]
    },
    {
        id: 14,
        name: 'Pennant Park',
        img: 'http://dev.imbibe.info/images/pennant-park/grid.jpg',
        url: '/brand-design/pennant-park',
        slideshow: [
            'http://dev.imbibe.info/images/pennant-park/01.jpg',
            'http://dev.imbibe.info/images/pennant-park/02.jpg',
            'http://dev.imbibe.info/images/pennant-park/03.jpg',
            'http://dev.imbibe.info/images/pennant-park/04.jpg',
        ]
    },
    {
        id: 15,
        name: 'Sandy Springs',
        img: 'http://dev.imbibe.info/images/sandy-springs/grid.jpg',
        url: '/brand-design/sandy-springs',
        slideshow: [
            'http://dev.imbibe.info/images/sandy-springs/01.jpg',
            'http://dev.imbibe.info/images/sandy-springs/02.jpg',
            'http://dev.imbibe.info/images/sandy-springs/03.jpg',
            'http://dev.imbibe.info/images/sandy-springs/04.jpg',
            'http://dev.imbibe.info/images/sandy-springs/animation.gif',
            'http://dev.imbibe.info/images/sandy-springs/08.jpg',
        ]
    },
    {
        id: 16,
        name: 'Revel',
        img: 'http://dev.imbibe.info/images/revel/grid.jpg',
        url: '/brand-design/revel',
        slideshow: [
            'http://dev.imbibe.info/images/revel/01.jpg',
            'http://dev.imbibe.info/images/revel/02.jpg',
            'http://dev.imbibe.info/images/revel/03.jpg',
            'http://dev.imbibe.info/images/revel/04.jpg',
        ]
    },
];

export default data;


// WEBPACK FOOTER //
// ./src/data/index.js